import {getAllRooms, storeRoom, moveUserToRoom, deleteRoom} from '../lib/roomService';
import moment from 'moment';

const initState = {
    rooms:[],
    events:[],
    showCreateRoom: false,
    availableRooms: [],
    showLoader: true,
};

const LOAD_ALL_ROOMS = 'LOAD_ALL_ROOMS';
const UPDATE_SHOW_CREATE_ROOM = 'UPDATE_SHOW_CREATE_ROOM';
const POPULATE_AVAILABLE_ROOMS =  'POPULATE_AVAILABLE_ROOMS';

export const loadAllRooms = (rooms) => ({type:LOAD_ALL_ROOMS,payload:rooms});
export const updateShowCreateRoom = (payload) => ({type: UPDATE_SHOW_CREATE_ROOM, payload});
export const populatedAvailableRooms = (slot_datetime) => ({type: POPULATE_AVAILABLE_ROOMS, payload: slot_datetime});

export const fetchAllRooms = () => {
    return (dispatch) => {
        getAllRooms().then(rooms => dispatch(loadAllRooms(rooms)));
    }
};

export const moveUser = (booking_id, room_id) => {
    return async () => {
        return await moveUserToRoom(booking_id, room_id);
    }
};

export const sendDeleteRoom = (room_id) => {
    return async () => {
        await deleteRoom(room_id);
    }
};

export const saveRoom = (room) => {
    return async (dispatch) => {
        await storeRoom(room);
    }
}

const NATO_WORDS = [
  "Alpha",
  "Bravo",
  "Charlie",
  "Delta",
  "Echo",
  "Foxtrot",
  "Golf",
  "Hotel",
  "India",
  "Juliett",
  "Kilo",
  "Lima",
  "Mike",
  "November",
  "Oscar",
  "Papa",
  "Quebec",
  "Romeo",
  "Sierra",
  "Tango",
  "Uniform",
  "Victor",
  "Whiskey",
  "Xray",
  "Yankee",
  "Zulu",
];

function getNatoRoomTitle(dateStr, index) {
  let hash = 0;
  for (let i = 0; i < dateStr.length; i++) {
    hash = (hash << 5) - hash + dateStr.charCodeAt(i);
    hash |= 0;
  }
  hash = Math.abs(hash);

  const shuffled = [...NATO_WORDS];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = (hash + i * 31) % (i + 1);
    const temp = shuffled[i];
    shuffled[i] = shuffled[j];
    shuffled[j] = temp;
  }

  const word = shuffled[index % shuffled.length];
  return `Room ${word}`;
}

export default (state = initState, action) => {
  switch (action.type) {
    case LOAD_ALL_ROOMS: {
      const roomsByDay = {};
      const roomsList = action.payload || [];

      // Group rooms by calendar date string (YYYY-MM-DD)
      roomsList.forEach((room) => {
        const dayKey = moment(room.slot_datetime).format("YYYY-MM-DD");
        if (!roomsByDay[dayKey]) {
          roomsByDay[dayKey] = [];
        }
        roomsByDay[dayKey].push(room);
      });

      const events = [];
      const updatedRooms = [];

      Object.keys(roomsByDay).forEach((dayKey) => {
        const dayRooms = roomsByDay[dayKey];
        // Sort rooms deterministically by id or slot_datetime
        dayRooms.sort(
          (a, b) =>
            new Date(a.slot_datetime) - new Date(b.slot_datetime) ||
            a.id - b.id
        );

        dayRooms.forEach((room, index) => {
          const natoTitle = getNatoRoomTitle(dayKey, index);
          // Use the room's custom title if it exists, otherwise fall back to NATO
          const displayTitle = room.title || natoTitle;
          room.title = displayTitle;
          updatedRooms.push(room);

          const start = moment(room.slot_datetime);
          let duration = 0;
          if (room.bookings && room.bookings.length > 0) {
            for (let booking of room.bookings) {
              if (booking.exam && booking.exam.duration > duration) {
                duration = booking.exam.duration;
              }
            }
          }
          const end = moment(room.slot_datetime).add(
            duration > 0 ? duration : 1,
            "hours"
          );
          const timeStr = `${start.format("h:mm A")} – ${end.format("h:mm A")}`;

          events.push({
            start: start._d,
            end: end._d,
            room,
            title: `${timeStr} - ${displayTitle}`,
          });
        });
      });

      return { ...state, rooms: updatedRooms, events, showLoader: false };
    }
        case UPDATE_SHOW_CREATE_ROOM:
            return {...state, showCreateRoom: action.payload};
        case POPULATE_AVAILABLE_ROOMS:
            //filter for rooms that are at the same time but not the current room
            const availableRooms = state.rooms.filter((room) => {
                if (room.slot_datetime === action.payload.slot_datetime && room.id !== action.payload.id) {
                    return room;
                }
            });
            return {...state, availableRooms};    
        default:
            return state;
    }
}
